<template>
  <div
    class="page-pilot-network"
    style="min-height: calc(100vh - 66px); padding-bottom: 20px; background: #fff;"
  >
    <div class="md-layout">
      <div class="header-wrapper">
        <div class="breadcrumbs">
          <span>{{ $t("Pilot Network") }} / </span>
          <span class="title">{{ $t("Flight Review") }}</span>
        </div>
        <div class="subtitle">
          <div>Flight Reviewers (Total {{ reviewerNumber }})</div>
          <div class="fs-12">
            Contact info will be disclosed after your booking.
          </div>
        </div>
      </div>
    </div>
    <ReviewerMap :reviewerNumberCbfn="reviewerNumberCbfn" />
  </div>
</template>

<script>
import "mapbox-gl/dist/mapbox-gl.css";
import ReviewerMap from "../Dashboard/Components/ReviewerMap.vue";

export default {
  name: "PilotNetwork",
  components: {
    ReviewerMap
  },
  data() {
    return {
      reviewerNumber: "--"
    };
  },
  methods: {
    reviewerNumberCbfn(num) {
      this.reviewerNumber = num;
    }
  }
};
</script>

<style lang="scss">
.page-pilot-network {
  .header-wrapper {
    margin-top: 100px;
    background: #fafafa;
    padding: 10px 24px;
    border-top: #ecf0f1 solid 1px;
    border-bottom: #ecf0f1 solid 1px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .subtitle {
    font-size: 13px;
    text-align: right;
  }
  .fs-12 {
    font-size: 12px;
  }
}
</style>
